import { lazy, Suspense } from 'react';

import { Skeleton } from '@/shared/components/ui/skeleton';

const ComponentsGallery = lazy(() =>
  import('./(dev)/components').then((m) => ({ default: m.ComponentsGallery })),
);

/**
 * Wrapper para a galeria de primitives da Phase 01, montada em
 * `/__dev__/components` apenas em DEV. Carregada via `React.lazy` para nao
 * pesar no bundle de producao (a rota tambem e strippada em prod via
 * `import.meta.env.DEV` no `routes.tsx`).
 */
export function GallerySuspense() {
  return (
    <Suspense
      fallback={
        <div className="container mx-auto max-w-3xl space-y-3 p-8">
          <Skeleton width="60%" height={32} />
          <Skeleton width="100%" height={120} />
          <Skeleton width="100%" height={120} />
        </div>
      }
    >
      <ComponentsGallery />
    </Suspense>
  );
}
